/** Matches the existing EditAvatar multipart contract, without sending empty updates. */
export function buildAvatarForm({ id, file, galleryId, currentGalleryId }) {
  const hasGallery = galleryId != null && galleryId !== "";
  if (!file && (!hasGallery || Number(galleryId) === Number(currentGalleryId))) return null;
  if (!Number.isSafeInteger(Number(id)) || Number(id) < 1) throw new Error("اطلاعات کاربر هنوز دریافت نشده است.");
  if (file && (!(file instanceof Blob) || !file.size || !file.type.startsWith("image/"))) throw new Error("فایل تصویر معتبر انتخاب کنید.");
  if (hasGallery && (!Number.isSafeInteger(Number(galleryId)) || Number(galleryId) < 1)) throw new Error("شناسه تصویر گالری معتبر نیست.");
  const form = new FormData(); form.append("id", String(id));
  // The existing controller requires a nonempty fromGallery even for a file upload.
  form.append("fromGallery", String(hasGallery ? galleryId : Number(currentGalleryId) > 0 ? currentGalleryId : 0));
  if (file) form.append("files", file);
  return form;
}
